<template>
    <inertia-head>
        <title>Rabatter från välkända varumärken - Våra partners</title>
        <link rel="canonical" :href="canonical" />
        <meta property="og:type" content="website" />
        <meta property="og:image" :content="`${$page.props.baseUrl}/assets/frontend/hero.jpg`" />
        <meta name="description" content="Här hittar du våra Partner-företag, välkända varumärken som t.ex. Expressen, viaplay, Comviq, CDON m.fl. Alla med rabattkoder till familjer!">
    </inertia-head>

    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="true">
            <span>Våra partners</span>
        </breadcrumb-item>
    </breadcrumb>

    <main role="main" class="main search-results page-content-padding">
        <div class="container">
            <h1 class="page-heading">Våra partners</h1>

            <p class="text-dark px-2 mx-auto" style="max-width: 800px; margin-top: 25px;">
                Varumärken vi jobbar extra nära med. Här hittar du välkända företag online men även stora lokala aktörer som ger dig som medlem stort mervärde. De säljer olika produkter, tjänster och upplevelser - men gemensamt är att de alltid serverar grymma deals, kampanjer och erbjudanden som passar alla familjer!
            </p>

            <div class="list-result container">
                <div class="row mt-2 card-deck">
                    <div class="col-6 col-md-3 card border-0 mx-0 p-1.5 mb-4" v-for="partner in partners" :key="partner.id" style="background-color:transparent;">
                        <inertia-link :href="redirectPartner(partner)">
                            <div class="bg-white mx-2">
                                <div class="card-body">
                                    <div v-if="partner.logo" class="cimagecontainer4-3-logo" :style="{ 'background-image': 'url(' + partner.logo + ')' }"> </div>
                                    <div class="cimagecontainer4-3-logo" style="position: relative;" v-else>
                                        <div style="position: absolute;left: 50%;top:50%;transform: translate(-50%,-50%);">{{ partner.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </inertia-link>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        props: ['partners', 'canonical'],

        data () {
            return {
                selectedCity: this.city ? this.city : 'Hela landet',
            }
        },

        computed: {
            city() {
                return this.$store.state.city;
            },
        },

        methods: {
            redirectPartner(company) {
                if (this.selectedCity === 'Hela landet') {
                    return `/${company.slug}`;
                }

                return `/${this.selectedCity.slug}/${company.slug}`;
            },
        }
    }
</script>
